module.exports = __webpack_public_path__ + "static/media/phone-square-alt.110b2bfa.svg";